// src/pages/VerifyOrResend.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function VerifyOrResend() {
  const navigate = useNavigate();

  const [mode, setMode] = useState("idle"); // idle | sending
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);


  const handleResend = async () => {
    setIsSubmitting(true);
    try {
      await API.post("/auth/resend-verification", { email });
      toast.success("If that email can be verified, a new link was sent.", {
        autoClose: 5000,
      });
      setMode("idle");
    } catch (err) {
      console.error("Resend error:", err);
      toast.error(
        err.response?.data?.message || "❌ Could not resend verification. Try again.",
        { autoClose: 5000 }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-paper flex items-center justify-center px-4">
      <ToastContainer position="top-center" />
      <div className="w-full max-w-md p-6 bg-white rounded-xl border border-line shadow-sm text-center">
        {mode === "idle" && (
          <>
            <img src="/Predict90Wordmark.png" alt="Predict90" className="h-8 w-auto mx-auto mb-5" />
            <h2 className="text-[22px] font-bold text-ink mb-2">
              Resend verification
            </h2>
            <p className="text-muted mb-4">
              Enter your email to receive a new verification link.
            </p>
            <input
              type="email"
              className="w-full h-11 px-3 mb-4 border border-line rounded-lg outline-none focus:border-brand"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isSubmitting}
            />
            <button
              onClick={handleResend}
              disabled={isSubmitting || !email}
              className={`w-full text-white font-semibold h-11 rounded-lg ${
                isSubmitting || !email
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-brand hover:bg-brand-hover"
              }`}
            >
              {isSubmitting ? "Sending…" : "Send Verification Email"}
            </button>
            <p className="text-sm text-gray-500 mt-4">A fresh link will be sent to your inbox.</p>
          </>
        )}
      </div>
    </div>
  );
}
